export default __webpack_public_path__ + "b15ebff0ef42131d455603ac141c9d10.png";